import { useDisclosure } from '@chakra-ui/react';
import { Modal, ModalCloseButton, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { useSnackbar } from '@components/snackbar';
import { SlackIcon } from '@sketchnote/icons';
import Tippy from '@tippyjs/react';
import classNames from 'classnames';
import React from 'react';
import { useFileAccess } from 'src/features/files/hooks/useFileAccess';

import { useFileExploreStore } from '../store';

export const SlackButton = () => {
  const { slackChannel, onRemoveSlackChannel, integrationId, slackAuthUrl } = useFileExploreStore();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [openSnackbar] = useSnackbar();

  const { isReadOnly } = useFileAccess();

  const handleChannelRemoval = () => {
    onRemoveSlackChannel({ id: integrationId }).then(({ status }) => {
      onClose();
      const message =
        status === 'success'
          ? 'The slack integration was removed'
          : 'There was an error in removing the slack integration';
      openSnackbar({
        text: message,
        snackType: 'standard',
        position: 'bottom-center',
      });
    });
  };

  const callSlackAuth = () => {
    window.location.href = slackAuthUrl;
  };

  return (
    <>
      {slackChannel ? (
        <Tippy
          content="You do not have the required permission to change connected slack channel"
          disabled={!isReadOnly}
        >
          <button
            className={classNames('border-gray-200 py-20 w-full pl-8', {
              'opacity-50 cursor-not-allowed': isReadOnly,
            })}
            onClick={isReadOnly ? undefined : onOpen}
          >
            <div className="flex items-center h-20">
              <SlackIcon size={30} />
              <div>
                <span className="text-sm">{slackChannel}</span>
              </div>
            </div>
            <span className="text-sm text-left text-gray-500 block">Connected slack channel</span>
          </button>
        </Tippy>
      ) : (
        <Tippy
          content="You do not have the required permission to connect slack channel"
          disabled={!isReadOnly}
        >
          <button
            onClick={isReadOnly ? undefined : callSlackAuth}
            className={classNames(
              'pl-8 flex py-20 justify-between text-gray-600 text-sm items-center border-t w-full border-gray-200 hover:text-gray-800 cursor-pointer',
              {
                'opacity-50 cursor-not-allowed': isReadOnly,
              }
            )}
          >
            <span>↗ Connect Slack channel</span>
          </button>
        </Tippy>
      )}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent
          style={{
            maxWidth: '46rem',
            padding: '32px',
            marginTop: '20rem',
            borderRadius: '8px',
          }}
        >
          <ModalCloseButton />
          <p className="mb-32 text-md text-gray-999">
            Are you sure you want to remove the Slack integration?
          </p>
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="border-blue-500 text-blue-500 border rounded-sm px-24 py-13 mr-8"
            >
              Cancel
            </button>
            <button
              className="border-red-700 text-red-700 border rounded-sm px-24 py-13"
              onClick={handleChannelRemoval}
            >
              Remove
            </button>
          </div>
        </ModalContent>
      </Modal>
    </>
  );
};
